import React, { Component } from "react";
// import { API_URL } from "../../config";
// import { IconButton } from "@material-ui/core";
// import DeleteIcon from "@material-ui/icons/Delete";
// import EditIcon from "@material-ui/icons/Edit";
import store from "../../Redux/Store";
import "./stepadd.css";
import { connect } from "react-redux";
//import Edit from "../assets/edit.png";
import Delete from "../assets/delete1.png";
import EditModal from "../Campaign/EditModal";
import swal from "sweetalert";
import { fetchMethod } from "../../FetchMethod";
import { EditCampaignStepsQuery, stepLogs } from "./campaignQueries";

class AddStepsSection extends Component {

  constructor(props) {
    super(props);
  }
  // updateSequence = (id) => {
  //   // debugger;
  //   const updateData = this.props.addModalStep.filter((item) => item.id !== id);
  //   console.log("object updateData",updateData)
  //   updateData.map((item, index) => {
  //     const key = index + 1;
  //     item.sequence = key;
  //     let test = {
  //       id: { id: item.id },
  //       data: item,
  //     };
  //     // debugger;
  //     fetchMethod(EditCampaignStepsQuery, test)
  //       .then((res) => {
  //         return res.json();
  //       })
  //       .then((response) => {})
  //       .catch((e) => console.log(e));
  //   });

  //   this.props.OnEditData(updateData);
  // };
  updateSequence = (id) => {

    const deletedItem = this.props.addModalStep.find((item) => item.id === id);
    if (!deletedItem) {
      // Item not found
      return;
    }
    const updateData = this.props.addModalStep.filter((item) => item.id !== id);
    const updateSequenceForOpen = (openValue) => {
      const filteredItems = updateData.filter(
        (item) => item.open === openValue
      );
      filteredItems.forEach((item) => {
        if (item.sequence > deletedItem.sequence) {
          item.sequence -= 1;
          let test = {
            id: { id: item.id },
            data: item,
          };
          fetchMethod(EditCampaignStepsQuery, test)
            .then((res) => res.json())
            .then((response) => {})
            .catch((e) => console.log(e));
        }
      });
    };
    updateSequenceForOpen(deletedItem.open);

    this.props.OnEditData(updateData);
  };

  onDelete = (item) => {
  
    if (item.active === 1 || item.active === "1") {
      swal({
        text:
          "Are you sure you want to delete this workflow step ?" +
          "\n" +
          " You would not be able to undo this.",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          const test = {
            id: { stepname: item.stepname, id: item.id },
            data: { active: 0 },
          };
          const logdata = {
            data: {
              stepid: item.id,
              action: 0,
              updatedby: localStorage.getItem("id"),
            },
          };
          fetchMethod(EditCampaignStepsQuery, test)
            .then((response) => {
              return response.json();
            })
            .then((res) => {
              this.updateSequence(item.id);
            })
            .then((res) => {
              fetchMethod(stepLogs, logdata).then((response) => {
                return response.json();
              });
            })
            .catch((e) => console.log(e));
        }
      });
    }
  };

  render() {
  
    let pos = 0;
    let posOpen0 = 0;
    let posOpen1 = 0;
    const leftSectionData = this.props.addModalStep.filter(
      (item) => item.open === 0
    );
    const rightSectionData = this.props.addModalStep.filter(
      (item) => item.open === 1
    );
    return (
      <React.Fragment>
        {this.props.addModalStep.length !== 0 ? (
          <div
            className="steps-container"
            style={{
              width: "100%",
              height: "auto",
              display: "flex",
              margin: "10px 0",
              gap: "10px",
            }}
          >
            {leftSectionData.length > 0 && this.props.campaignWorkflowClickType == "Standard" && (
            // {leftSectionData.length > 0 && (
              <div
                className="steps-section"
                style={{ flex: "1", position: "relative", width:"50%" }}
              >
                {leftSectionData?.map((item, index) => {
                  if (
                    item.stepname === "SEND_MESSAGE" ||
                    item.stepname === "SEND_EMAIL"
                  ) {
                    pos = pos + 1;
                  }
                  posOpen0++;

                  return (
                    <div className="stepAdd" style={{ marginTop: "4%" }}>
                      <span>Step {" " + posOpen0}</span>
                      <div style={{ marginLeft: "10px", width:"85%" }}>
                        <h3>
                          {item.stepname === "SEND_INVITE"
                            ? "Send Invite"
                            : item.stepname === "VISIT"
                            ? "Visit Profile"
                            : item.stepname === "FOLLOW"
                            ? "Follow Profile"
                            : item.stepname === "SEND_THANKS_MESSAGE"
                            ? "Send Thanks Message"
                            : item.stepname === "SEND_MESSAGE"
                            ? "Send Message "
                            : item.stepname === "SEND_EMAIL"
                            ? "Send InMail "
                            : ""}
                        </h3>

                        {item.stepname === "SEND_INVITE" ? (
                          <p>
                            <p>{item.message}</p>
                            Max {item.limitperday} invites
                          </p>
                        ) : item.stepname === "SEND_MESSAGE" ? (
                          <p>
                            <p>{item.message}</p>
                            {item.limitperday
                              ? "Max " + item.limitperday + " messages"
                              : ""}
                          </p>
                        ) : item.stepname === "SEND_EMAIL" ? (
                          <p>
                            <p>{item.message}</p>
                            {item.limitperday
                              ? "Max " + item.limitperday + " messages"
                              : ""}
                          </p>
                        ) : item.stepname === "VISIT" ? (
                          <p>Max {item.limitperday} visits</p>
                        ) : item.stepname === "SEND_THANKS_MESSAGE" ? (
                          <p>
                            <p>{item.message}</p>
                            {item.limitperday
                              ? "Max " + item.limitperday + " thanks messages"
                              : ""}
                          </p>
                        ) : (
                          <p>Max {item.limitperday} follows</p>
                        )}
                      </div>
                      <div className="Icons">
                        <div className="iconbuttonEdit">
                          <EditModal editableData={item} />
                        </div>
                        <div className="iconbuttonDelete">
                          <div
                            title="Delete"
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              localStorage.getItem("role") !== "CAMPAIGNMANAGER"
                                ? store.getState().isEditMode === true
                                  ? this.onDelete(item)
                                  : swal({
                                      text:
                                        "Are you sure you want to delete this workflow step ?" +
                                        "\n" +
                                        " You would not be able to undo this.",
                                      icon: "warning",
                                      buttons: true,
                                      dangerMode: true,
                                    }).then((willDelete) => {
                                      if (willDelete) {
                                        this.props.OnDelete(item.stepname);
                                      }
                                    })
                                : ""
                            }
                          >
                            <img src={Delete} alt="Delete" />
                          </div>
                        </div>
                        <br />
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
            {/* {rightSectionData.length > 0 && leftSectionData.length > 0 && (
              <div
                className="verticalLine"
                style={{ width: "2px", height: "auto", background: "gray" }}
              ></div>
            )} */}
            {rightSectionData.length > 0 && this.props.campaignWorkflowClickType == "Open" && (
              <div
                className="steps-section"
                style={{ flex: "1", position: "relative", width:"48%" }}
              >
                {rightSectionData?.map((item, index) => {
               
                  if (
                    item.stepname === "SEND_MESSAGE" ||
                    item.stepname === "SEND_EMAIL"
                  ) {
                    pos = pos + 1;
                  }
                  posOpen1++;

                  return (
                    <div className="stepAdd" style={{ marginTop: "4%" }}>
                      <span>Step {" " + posOpen1}</span>
                      <div style={{ marginLeft: "10px", width:"85%"  }}>
                        <h3>
                          {item.stepname === "SEND_INVITE"
                            ? "Send Invite"
                            : item.stepname === "VISIT"
                            ? "Visit Profile"
                            : item.stepname === "FOLLOW"
                            ? "Follow Profile"
                            : item.stepname === "SEND_THANKS_MESSAGE"
                            ? "Send Thanks Message"
                            : item.stepname === "SEND_MESSAGE"
                            ? "Send Message "
                            : item.stepname === "SEND_EMAIL"
                            ? "Send InMail "
                            : ""}
                        </h3>

                        {item.stepname === "SEND_INVITE" ? (
                          <p>
                            <p>{item.message}</p>
                            Max {item.limitperday} invites
                          </p>
                        ) : item.stepname === "SEND_MESSAGE" ? (
                          <p>
                            <p>{item.message}</p>
                            {item.limitperday
                              ? "Max " + item.limitperday + " messages"
                              : ""}
                          </p>
                        ) : item.stepname === "SEND_EMAIL" ? (
                          <p>
                            <p>{item.message}</p>
                            {item.limitperday
                              ? "Max " + item.limitperday + " messages"
                              : ""}
                          </p>
                        ) : item.stepname === "VISIT" ? (
                          <p>Max {item.limitperday} visits</p>
                        ) : item.stepname === "SEND_THANKS_MESSAGE" ? (
                          <p>
                            <p>{item.message}</p>
                            {item.limitperday
                              ? "Max " + item.limitperday + " thanks messages"
                              : ""}
                          </p>
                        ) : (
                          <p>Max {item.limitperday} follows</p>
                        )}
                      </div>
                      <div className="Icons">
                        <div className="iconbuttonEdit">
                          <EditModal editableData={item} />
                        </div>
                        <div className="iconbuttonDelete">
                          <div
                            title="Delete"
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              localStorage.getItem("role") !== "CAMPAIGNMANAGER"
                                ? store.getState().isEditMode === true
                                  ? this.onDelete(item)
                                  : swal({
                                      text:
                                        "Are you sure you want to delete this workflow step ?" +
                                        "\n" +
                                        " You would not be able to undo this.",
                                      icon: "warning",
                                      buttons: true,
                                      dangerMode: true,
                                    }).then((willDelete) => {
                                      if (willDelete) {
                                        this.props.OnDelete(item.stepname);
                                      }
                                    })
                                : ""
                            }
                          >
                            <img src={Delete} alt="Delete" />
                          </div>
                        </div>
                        <br />
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        ) : (
          <div className="Heading">
            <h5>No workflow step added...</h5>
          </div>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {

  const { addModalStep, campaignWorkflowClickType } = state;
  return { addModalStep, campaignWorkflowClickType };
};
const mapDispatchToProps = (dispatch) => {
 
  return {
    OnDelete: (step) => dispatch({ type: "DELETE_ADDSTEPS", Modal_step: step }),

    OnEditData: (updateData) =>
      dispatch({ type: "Edit_Step_Data", StepId: updateData }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddStepsSection);
